import { render } from "./textContent.vue?vue&type=template&id=1321e956"
import script from "./textContent.vue?vue&type=script&lang=js"
export * from "./textContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__